import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import VideoCard from '@/components/base/VideoCard';
import CategoryTabs from '@/components/base/CategoryTabs';
import { categories, getCategoryBySlug } from '@/mocks/categories';
import { getVideosByCategory } from '@/mocks/videos';
import NotFound from '@/pages/NotFound';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? getCategoryBySlug(slug) : undefined;

  if (!category) {
    return <NotFound />;
  }

  const categoryVideos = getVideosByCategory(slug!);

  const jsonLdWebPage = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 91视频在线观看`,
    description: `91视频${category.name}分类，${category.description}。高清视频免费在线观看。`,
    url: `https://91video.com/category/${category.slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '91视频在线观看',
      url: 'https://91video.com/',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLdWebPage)}</script>
      <Navbar />
      <main className="pt-20">
        <div className="px-4 md:px-6 py-8">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: category.name },
              ]}
            />

            <div className="mt-4">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                  <i className={`${category.icon} text-xl`}></i>
                </div>
                <div>
                  <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                    {category.name}
                  </h1>
                  <p className="text-sm text-foreground-500">{category.description}</p>
                </div>
              </div>
            </div>

            <div className="mt-6 mb-8">
              <CategoryTabs categories={categories} activeSlug={category.slug} />
            </div>

            {categoryVideos.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {categoryVideos.map((video) => (
                  <VideoCard key={video.id} video={video} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-2xl bg-background-100 text-foreground-400">
                  <i className="ri-video-line text-2xl"></i>
                </div>
                <p className="mt-4 text-foreground-500">该分类暂无视频，请浏览其他分类</p>
                <Link to="/" className="inline-block mt-4 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap">
                  返回首页
                </Link>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}